import { Grid, IconButton, makeStyles } from '@material-ui/core'

import {
  ERROR_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS
} from 'asterX-UI'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import { CheckCircleIcon, MinusCircleIcon } from 'asterX-UI/Icons'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { Modal } from 'asterX-UI/Modals'
import { a11yProps, Tab, Tabs } from 'asterX-UI/Tabs'

import WorkListViewStoreProviderMn, {
  useWorkListViewMnStore
} from 'context/WorkListViewStore/Manager/WorkListViewStore.manager'
import { useResErrors, useRoutes } from 'hooks'

import ClientNeeds from 'components/Desktop/ClientNeeds'
import HistoryOfSelection from 'components/Desktop/HistoryOfSelection'
import ClientView from 'components/Desktop/WorkListView/ClientView'
import CommentsTab from 'components/Desktop/WorkListView/CommentsTab'
import Header from 'components/Desktop/WorkListView/Header'
import StatusProgress from 'components/Desktop/WorkListView/StatusProgress'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import { useAuthStore } from 'context/AuthStore'
import { useWorkListStoreManager } from 'context/HomeStore/Manager/WorkListsProvider/WorkListProvider.manager'
import { parseJson } from 'lib/utils'
import CallsTab from 'pages/Desktop/WorkListView/Manager/Tabs/Calls/CallsTab'
import CreditRequestsTab from 'pages/Desktop/WorkListView/Manager/Tabs/CreditRequests/CreditRequestsTab'
import PaymentsTab from 'pages/Desktop/WorkListView/Manager/Tabs/Payments/PaymentsTab'
import TaskTab from 'pages/Desktop/WorkListView/Manager/Tabs/Tasks/TaskTab'
import WlAssessmentsTab from 'pages/Desktop/WorkListView/Manager/Tabs/WlAssessments/WlAssessmentsTab'

const WorkListViewManagerDesktop = props => (
  <WorkListViewStoreProviderMn {...props}>
    <WorkListView />
  </WorkListViewStoreProviderMn>
)

export default WorkListViewManagerDesktop

export const WorkListViewManagerDesktopModal = ({
  open,
  onClose,
  ...props
}) => (
  <WorkListViewStoreProviderMn {...props}>
    <Modal open={open} onClose={onClose} fullWidth maxWidth={'md'}>
      <WorkListView isModal onClose={onClose} />
    </Modal>
  </WorkListViewStoreProviderMn>
)

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 4
  },
  checkRop: {
    display: 'flex',
    gap: 6
  },
  text: {
    color: GRAY_COLORS[700],
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    fontFamily: 'Inter'
  }
}))

const TabLabel = ({ count, isActive, label }) => {
  return (
    <div
      style={{
        alignItems: 'center',
        gap: 8,
        display: 'flex'
      }}
    >
      {' '}
      {label}
      {count > 0 && (
        <ChipStandard
          {...(isActive
            ? {
                color: PRIMARY_COLORS[700],
                backgroundColor: PRIMARY_COLORS[100]
              }
            : {
                color: GRAY_COLORS[700],
                backgroundColor: GRAY_COLORS[100]
              })}
        >
          {count}
        </ChipStandard>
      )}
    </div>
  )
}

const WorkListView = ({ isModal, onClose = () => {} }) => {
  const tabsList = [
    {
      label: 'Все',
      value: 'COMMENTS'
    },
    {
      label: 'Результаты задачи',
      value: '@result'
    },
    {
      label: 'Причина упущенных',
      value: 'MISSING'
    },
    {
      label: 'Фин сервис',
      value: 'FINSERVICE'
    }
  ]

  const { goPrevPage } = useRoutes()
  const classes = useStyles()
  const { workListViewStore, workListViewStoreFunc } = useWorkListViewMnStore()

  const { sale, comments } = workListViewStore

  const configTabs = () => {
    return [
      {
        label: (
          <TabLabel
            label={'Задачи'}
            count={workListViewStore.taskList?.length}
            isActive={workListViewStore.selectedTab === 0}
          />
        ),
        value: 0
      },
      { label: 'Комментарии', value: 1 },
      { label: 'Кредитные заявки', value: 2 },
      { label: 'Звонки', value: 3 },
      { label: 'РЛ оценки', value: 4 },
      { label: '1С и оплата', value: 5 },
      { label: 'Потребности клиента', value: 6 },
      { label: 'История подбора', value: 7 }
    ]
  }

  const tabsContent = [
    <TaskTab />,
    <CommentsTab
      comments={comments}
      tabsList={tabsList}
      onAddComment={workListViewStoreFunc.addComments}
    />,
    <CreditRequestsTab />,
    <CallsTab />,
    <WlAssessmentsTab />,
    <PaymentsTab />,
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        gap: 5,
        padding: 10
      }}
    >
      <ClientNeeds isDisabled commentsRSE={parseJson(sale.commentsRSE)} />
    </div>,
    <HistoryOfSelection id={sale?.id} tradeInCarVin={sale?.tradeInCarVin} />
  ]

  return (
    <PageContainerDesktop
      customHeader={
        <div className={classes.header}>
          <IconButton
            style={{
              color: '#667085'
            }}
            onClick={isModal ? onClose : goPrevPage}
            size={'small'}
          >
            <ChevronLeftIcon />
          </IconButton>

          <div className={classes.checkRop}>
            {sale?.ropCheck ? (
              <>
                <CheckCircleIcon
                  style={{
                    color: SUCCESS_COLORS[600],
                    fontSize: 18
                  }}
                />
                <div className={classes.text}>{'Проверено РОП-ом'}</div>
              </>
            ) : (
              <>
                <MinusCircleIcon
                  style={{
                    color: ERROR_COLORS[600],
                    fontSize: 18
                  }}
                />
                <div className={classes.text}>{'РОП не проверил'}</div>
              </>
            )}
          </div>
        </div>
      }
    >
      <LoaderBackdrop
        loading={workListViewStore.initLoading || workListViewStore.loading}
      />

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Header
            wlId={sale?.id}
            status={sale?.saleStatus}
            carfinStatus={sale?.carfinStatus}
            globalId={sale?.globalId}
          />
        </Grid>

        {sale?.contractStatusTrack?.name && (
          <Grid item xs={12}>
            <StatusProgress contractStatusTrack={sale?.contractStatusTrack} />
          </Grid>
        )}

        <Grid item xs={12}>
          <ClientView sale={sale} />
        </Grid>

        <Grid item xs={12}>
          <Tabs
            value={workListViewStore.selectedTab}
            onChange={workListViewStoreFunc.onChangeTab}
            variant="scrollable"
            scrollButtons="auto"
            indicatorColor="primary"
            textColor="primary"
          >
            {configTabs().map((tab, index) => (
              <Tab
                label={tab.label}
                {...a11yProps(tab.value)}
                value={tab.value}
                key={`tab_${index}`}
              />
            ))}
          </Tabs>
        </Grid>

        {tabsContent[workListViewStore.selectedTab]}
      </Grid>
    </PageContainerDesktop>
  )
}
